/*
 * @Author: Hallie Liu 
 * @Date:
 * @Last Modified by: Hallie Liu
 * @Last Modified time: 2019-05-27 15:43:47
 */
'use strict'

import { BRANDWALL } from "../constants/ActionTypes"

const initState = {
    GET_BRAND_WALL_INFO : null,
    SET_OFFSETTOP : [],
    SET_TOP : null,
    CHANGE_CURRENT_LETTER_BG : '',
    AD_IMG : null,
    AD_TEXT : null,
    // BRAND_STORY_LINK : null
}

export default function ( state = initState, action = {} ){
    let SET_OFFSETTOP = action.SET_OFFSETTOP;
    let SET_HOT_BRAND_OFFSETTOP = action.SET_HOT_BRAND_OFFSETTOP;
    switch( action.type ){

        case BRANDWALL.GET_BRAND_WALL_INFO :
            return Object.assign({},state,{
                GET_BRAND_WALL_INFO:action.BRAND_WALL_INFO
            });
        break;

        case BRANDWALL.SET_OFFSETTOP :
        return Object.assign({},state,{
            SET_OFFSETTOP : [
                ...state.SET_OFFSETTOP,
                SET_OFFSETTOP
            ]
        })
        break;

        case BRANDWALL.SET_HOT_BRAND_OFFSETTOP :
        return Object.assign({},state,{
            SET_OFFSETTOP : [
                SET_HOT_BRAND_OFFSETTOP,
                ...state.SET_OFFSETTOP
            ]
        })
        break;

        case BRANDWALL.SET_TOP :
            return Object.assign({},state,{
                SET_TOP : action.val
            });
        break;

        case BRANDWALL.CHANGE_CURRENT_LETTER_BG :
            return Object.assign({},state,{
                CHANGE_CURRENT_LETTER_BG : action.val
            });
        break;

        case BRANDWALL.GET_AD_IMG :
            return Object.assign({},state,{
                AD_IMG : action.AD_IMG
            });
        break;

        case BRANDWALL.GET_AD_TEXT :
            return Object.assign({},state,{
                AD_TEXT : action.AD_TEXT
            });
        break;

        // case BRANDWALL.BRAND_STORY_LINK :
        //     return Object.assign({},state,{
        //         BRAND_STORY_LINK : action.BRAND_STORY_LINK
        //     });
        // break;

        default:
            return state;break;
    }
}





// WEBPACK FOOTER //
// ./common/reducers/brandWall.js